// import translations

const audienceFeatures = [
  {
    name: 'number_of_survey',
    label: 'Unlimited number of surveys',
    included: true,
  },
  {
    name: 'create_question_limit',
    label: '50 questions per survey',
    included: true,
  },
  {
    name: 'number_of_response',
    label: 'Unlimited responses',
    included: true,
  },
  {
    name: 'email_support',
    label: '24/7 customer support via email',
    included: true,
  },
  {
    name: 'customized_survey',
    label: 'Custom colors & survey URL',
    included: true,
  },
  {
    name: 'analyze_export_enabled',
    label: 'Data exports (CSV, PDF, PPT, XLS)',
    included: true,
  },
  {
    name: 'skip_logic',
    label: 'Skip logic',
    included: true,
  },
  {
    name: 'question_answer_piping',
    label: 'Question & answer piping',
    included: true,
  },
  {
    name: 'file_upload',
    label: 'File upload',
    included: false,
  },
  {
    name: 'create_random_assignment_enabled',
    label: 'A/B test text and images',
    included: true,
  },
  {
    name: 'create_toggle_footer_enabled',
    label: 'Hide SurveyMonkey footer',
    included: true,
  },
  {
    name: 'multilingual',
    label: 'Multilingual surveys',
    included: true,
  },
];

export default audienceFeatures;
